<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail">
        <a-row>
          <a-col :span="24" v-if="siteSelectShow">
            <a-form-model-item label="專區" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="siteId">
              <a-select allowClear v-model='model.siteId'   @change="siteChange" >
                <a-select-option v-for="(item,index) in siteList" :key='index' :value='item.id' :label='item.text' >
                  {{item.siteName}}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="内容編碼" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentCode">
              <a-input v-model="model.contentCode" placeholder="自動生成" disabled ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="内容名称" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentName">
              <a-input v-model="model.contentName" placeholder="请输入内容名称"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="内容圖片" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentImg">
              <j-image-upload class="avatar-uploader" :text="'上傳'" v-model="model.contentImg" upload-source="hhemp" :disabled="formDisabled"/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="内容描述" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentDesc">
              <a-input v-model="model.contentDesc" placeholder="请输入内容描述"  ></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="status">
              <!--<a-input v-model="model.status" placeholder="请输入状态(published:已发布；unpublished:未发布)"  ></a-input>-->
              <j-dict-select-tag :type="'radio'" v-model="model.status" dictCode="empzone_content_status" allow-clear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24">
            <a-form-model-item label="內容類型" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentType">
              <!--<a-input v-model="model.status" placeholder="请输入状态(published:已发布；unpublished:未发布)"  ></a-input>-->
              <j-dict-select-tag :type="'radio'" v-model="model.contentType" dictCode="empzone_content_contentType" allow-clear/>
            </a-form-model-item>
          </a-col>
          <a-col :span="24" v-if="model.contentType=='Attachment'">
            <a-form-model-item label="附件" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="fileUrl">
              <!--<a-input v-model="model.fileUrl" placeholder="请输入文件"  ></a-input>-->
              <j-upload
                :newWindowOpen="`true`"
                upload-source="hhemp"
                bizPath="null"
                :multiple="false"
                :disabled="formDisabled"
                v-model="model.fileUrl"
              ></j-upload>
            </a-form-model-item>
          </a-col>
          <div v-if="model.contentType=='service'||model.contentType=='course'">
            <a-col :span="24">
              <a-form-model-item label="内容链接" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentUrl">
                <a-input v-model="model.contentUrl" placeholder="请输入内容链接"  ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="内容管理单位" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="contentManage">
                <a-input v-model="model.contentManage" placeholder="请输入内容管理单位"  ></a-input>
              </a-form-model-item>
            </a-col>
          </div>

          <div v-if="model.contentType=='unit'">
            <a-col :span="24">
              <a-form-model-item label="單位名稱" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="unitName">
                <a-input v-model="model.unitName" placeholder="请输入單位名稱"  ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="單位介紹" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="unitIntroduction">
                <a-input v-model="model.unitIntroduction" placeholder="请输入單位介紹"  ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="聯繫人" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="unitContact">
                <a-input v-model="model.unitContact" placeholder="请输入聯繫人"  ></a-input>
              </a-form-model-item>
            </a-col>
            <a-col :span="24">
              <a-form-model-item label="聯繫方式" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                <a-input v-model="model.unitTelephone" placeholder="请输入座機" style="width: 30%;" />
                <a-input v-model="model.unitPhone" placeholder="请输入手機"  style="width: 30%;left: 5%" />
                <a-input v-model="model.unitMail" placeholder="请输入郵箱"  style="width: 30%;left: 10%" />
              </a-form-model-item>
            </a-col>

          </div>
          <a-col :span="24">
            <a-form-model-item label="排序" :labelCol="labelCol" :wrapperCol="wrapperCol" prop="sortNo">
              <a-input-number v-model="model.sortNo" placeholder="请输入排序"  style="width:100%"></a-input-number>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'EmpzoneContentForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        siteList:[],
        siteSelectShow:false,
        model:{
         },
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          siteId: [
            { required: true, message: '請選擇專區'},
          ],
          contentName: [
            { required: true, message: '請輸入名稱'},
          ],
          /*contentUrl: [
            { required: true, message: '請輸入鏈接'},
          ],*/
          contentType: [
            { required: true, message: '請選擇內容類型'},
          ],
          sortNo: [
            { required: true, message: '請輸入排序'},
          ],
        },
        url: {
          add: "/empzone/content/add",
          edit: "/empzone/content/edit",
          queryById: "/content/empzonecontent/"
        }
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
    },
    created () {
      this.initSiteList();
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      initSiteList(){
        getAction("/empzone/site/list").then(res=>{
          if(res.success){
            this.siteList = res.result;
          }
        })
      },
      siteChange(id){
        const selected = this.siteList.find(item => item.id === id)
        this.$set(this.model,'siteCode',selected.siteCode)
      },
      add () {
        this.modelDefault.status = 'unpublished'
        this.edit(this.modelDefault);
      },
      edit (record) {
        const selected = this.siteList.find(item => item.siteCode === this.$store.getters.application.applicationCode)
        if(selected){
          record.siteId = selected.id
          record.siteCode = selected.siteCode
          this.siteSelectShow = false;
        }else{
          this.siteSelectShow = true;
        }
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            if(this.model.contentType=='Attachment'){
              this.$set(this.model,'contentUrl','')
              this.$set(this.model,'contentManage','')

              this.$set(this.model,'unitName','')
              this.$set(this.model,'unitIntroduction','')
              this.$set(this.model,'unitContact','')
              this.$set(this.model,'unitTelephone','')
              this.$set(this.model,'unitPhone','')
              this.$set(this.model,'unitMail','')
            }else if(this.model.contentType=='service'||this.model.contentType=='course'){
              this.$set(this.model,'fileUrl','')

              this.$set(this.model,'unitName','')
              this.$set(this.model,'unitIntroduction','')
              this.$set(this.model,'unitContact','')
              this.$set(this.model,'unitTelephone','')
              this.$set(this.model,'unitPhone','')
              this.$set(this.model,'unitMail','')
            }else if(this.model.contentType=='unit'){
              this.$set(this.model,'contentUrl','')
              this.$set(this.model,'contentManage','')

              this.$set(this.model,'fileUrl','')
            }
            httpAction(httpurl,this.model,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
    }
  }
</script>
